import Modal from "components/modal"
import { jewlr_t } from "helpers/application"

const ReturnPolicyModal = () => (
  <Modal
    label="Returns & Orders"
    show="#return-policy"
    variant="squircle"
    width="790px"
  >
    <h3 className="text-25 leading-36 mb-10 text-center font-normal">
      99-Day Return Policy
    </h3>
    <div className="text-18 leading-22 font-light">
      <p>
        We want you to feel comfortable and confident when shopping at Jewlr.
        That is why we offer an easy, hassle-free 99-day return policy. If you
        are not completely satisfied with your purchase you may return it for a
        full refund (minus any {jewlr_t("terms.shipping")} and/or gift packaging
        charges, if any) within 99 days of the original{" "}
        {jewlr_t("terms.shipping")} date. Upon receipt of your return, items are
        inspected for signs of wear or damage. If accepted, refunds will be
        issued to the original form of payment.
      </p>
      <ul>
        <li>
          Any item purchased from Jewlr can be returned, including engraved
          items
        </li>
        <li>The item(s) must be returned in a new and unworn condition</li>
        <li>
          Any promotional gifts must also be returned with your returned item
        </li>
        <li>
          Items which have been resized, updated and/or repaired do not qualify
        </li>
        <li>
          You will be responsible for the return {jewlr_t("terms.shipping")}{" "}
          cost
        </li>
      </ul>
    </div>
  </Modal>
)

export default ReturnPolicyModal
